import { Ad } from "@models/Ad.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class AdSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    if (data.children && Array.isArray(data.children)) {
      data.children = data.children.map((child: any) => this.deserialize(child));
    }
    const ad = new Ad();
    this._copyAttributesValue(ad, data);
    return ad;
  }
}
